/* eslint-disable @stylistic/no-multi-spaces */
/* eslint-disable @stylistic/quote-props */
/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Composables
import { createVuetify } from 'vuetify'
// Styles
import '@mdi/font/css/materialdesignicons.css'

import 'vuetify/styles'

// const customTheme = {
//   dark: false,
//   colors: {
//     primary: 'rgb(167, 112, 57)',         // Main accent
//     secondary: 'rgb(226, 168, 103)',      // Secondary accent
//     background: 'rgb(247, 242, 226)',     // App background
//     surface: 'rgb(247, 242, 226)',        // Card and surface background
//     'on-primary': 'rgb(247, 242, 226)',   // Text on primary
//     'on-secondary': 'rgb(167, 112, 57)',  // Text on secondary
//     'on-background': 'rgb(167, 112, 57)', // Text on background
//     'on-surface': 'rgb(167, 112, 57)',    // Text on surface
//   },
// }

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
// export default createVuetify({
//   theme: {
//     // defaultTheme: 'system',
//     defaultTheme: 'light',
//   },
// })

const cardboardTheme = {
  dark: false,
  colors: {
    primary: '#A77039',         // Cardboard brown
    secondary: '#E2A867',       // Packing tape tan
    accent: '#C19A6B',          // Corrugated edge
    background: '#F7F2E2',      // Packing paper/label
    surface: '#F3E6D0',         // Lighter box interior
    'on-primary': '#F7F2E2',    // Text on cardboard
    'on-secondary': '#6B4A23',  // Text on tape
    'on-background': '#6B4A23', // Text on background
    'on-surface': '#A77039',    // Text on surface
    info: '#BCA16B',            // Label yellow
    success: '#8D9440',         // Green sticker
    warning: '#E2A867',         // Tape
    error: '#B85C38',           // Fragile stamp
  },
}

export default createVuetify({
  theme: {
    // defaultTheme: 'system',
    defaultTheme: 'cardboardTheme',
    themes: {
      cardboardTheme,
    },
  },
})
